import React, { useCallback } from "react";
import "./App.css";
import { NavBar } from "./components/NavBar";
import { Hero } from "./components/Hero";
import { Timeline } from "./components/Timeline";
import { HallOfShame } from "./components/HallOfShame";
import { Gallery } from "./components/Gallery";
import { SubmitSection } from "./components/SubmitSection";
import { Footer } from "./components/Footer";
import { Toaster } from "sonner";

function App() {
  const scrollTo = useCallback((id) => {
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <NavBar onJump={scrollTo} />
      <main>
        <Hero onJump={scrollTo} />
        <Timeline />
        <HallOfShame />
        <Gallery />
        <SubmitSection />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          unstyled: true,
          className: "font-mono text-xs font-bold uppercase bg-[#FFEA00] text-black px-4 py-3 brutal-border flex items-center gap-2",
          style: { border: "4px solid #fff", boxShadow: "6px 6px 0 0 #FF003C" },
        }}
      />
    </div>
  );
}

export default App;
